import { render, staticRenderFns } from "./InputRadios.vue?vue&type=template&id=2860a4f3&scoped=true"
import script from "./InputRadios.vue?vue&type=script&lang=js"
export * from "./InputRadios.vue?vue&type=script&lang=js"
import style0 from "./InputRadios.vue?vue&type=style&index=0&id=2860a4f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860a4f3",
  null
  
)

export default component.exports